import React from 'react';

import Navbar from '../components/Navbar/Navbar';
import Contact from '../components/Contact/Contact';
import Footer from '../components/Footer/Footer';

export default function ContactPage() {
  return (
    <div>
      ContactPage
      <Navbar />
      <Contact />
      <Footer />
    </div>
  );
}
